(() => {
	if (customElements.get("featured-images")) {
		return;
	}

	class FeaturedImages extends HTMLElement {
		constructor() {
			super();

			this.slider = {};
		}

		connectedCallback() {
			this.slider = new Splide(this.querySelector("[data-slider]"), {
				arrows: false,
				breakpoints: {
					990: {
						drag: true,
						fixedWidth: "78.3%",
					},
				},
				drag: false,
				fixedWidth: "calc(100% / 3)",
				gap: "0.5rem",
			}).mount();
		}
	}

	customElements.define("featured-images", FeaturedImages);
})();
